import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, vShow as _vShow, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-77038795"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "coverage-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-text"
}, " Define supply settings to be used to compute your reordering needs. ", -1));
const _hoisted_3 = {
  class: "coverage-content"
};
const _hoisted_4 = {
  class: "coverage-box"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-box-top-left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "coverage-box-top-title"
}, "First comers"), /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-box-top-text"
}, "Define a target inventory coverage for your products leveraging your leadtime, reorder frequency and buffer stock")], -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-border"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-title"
}, " Leadtime ", -1));
const _hoisted_8 = {
  class: "coverage-row"
};
const _hoisted_9 = {
  class: "coverage-cell-info"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-text"
}, "🏭 Supplier Manufacturing LT", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-days"
}, " days ", -1));
const _hoisted_12 = {
  class: "coverage-row"
};
const _hoisted_13 = {
  class: "coverage-cell-info"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-text"
}, "🚧 Supplier Preparation LT", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-days"
}, " days ", -1));
const _hoisted_16 = {
  class: "coverage-row"
};
const _hoisted_17 = {
  class: "coverage-cell-info"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-text"
}, "🚚 Supplier to AMZ transport LT", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-days"
}, " days ", -1));
const _hoisted_20 = {
  class: "coverage-row"
};
const _hoisted_21 = {
  class: "coverage-cell-info"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-text"
}, "📥 AMZ preparation leadtime", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-days"
}, " days ", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-title"
}, " Inventory management ", -1));
const _hoisted_25 = {
  class: "coverage-row"
};
const _hoisted_26 = {
  class: "coverage-cell-info"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-text"
}, "Target order frequency", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-days"
}, " days ", -1));
const _hoisted_29 = {
  class: "coverage-cell-info"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-text"
}, "FBA Buffer Stock", -1));
const _hoisted_31 = {
  class: "coverage-badge",
  id: "learn-more"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-badge-text"
}, "Learn more", -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "color": "#fff",
    "font-size": "14px",
    "font-weight": "500",
    "padding": "0",
    "text-align": "left"
  }
}, " FBA Buffer Stock ", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "margin": "0",
    "text-align": "left",
    "color": "#ADADAD"
  }
}, " FBA Buffer Stock is a safety stock that helps cover any delays in the supply chain. It is calculated using standard safety stock formulas, aiming for 95% stock coverage against uncertainties. ", -1));
const _hoisted_35 = ["value"];
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-days"
}, " days ", -1));
const _hoisted_37 = {
  class: "coverage-row gray"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-info"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-text"
}, "Total Coverage")], -1));
const _hoisted_39 = {
  class: "coverage-cell-value"
};
const _hoisted_40 = {
  class: "coverage-cell-value-text"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-cell-days"
}, " days ", -1));
const _hoisted_42 = {
  class: "coverage-box"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-box-top-left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "coverage-box-top-title"
}, "Slow movers"), /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-box-top-text"
}, "Define specific inventory replenishment rules for products with lower sales.")], -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-border"
}, null, -1));
const _hoisted_45 = {
  class: "slow-movers-content"
};
const _hoisted_46 = {
  class: "slow-movers-box"
};
const _hoisted_47 = {
  class: "slow-movers-info"
};
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slow-movers-text"
}, "30d velocity threshold", -1));
const _hoisted_49 = {
  class: "slow-movers-box"
};
const _hoisted_50 = {
  class: "slow-movers-info"
};
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slow-movers-text"
}, "Target inventory", -1));
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-line"
}, null, -1));
const _hoisted_53 = {
  class: "packaging-row"
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "packaging-info"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "packaging-title"
}, "Packaging"), /*#__PURE__*/_createElementVNode("div", {
  class: "packaging-text"
}, "Round up orders to the nearest carton")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_demand_forecasting_settings_popover = _resolveComponent("demand-forecasting-settings-popover");
  const _component_app_input = _resolveComponent("app-input");
  const _component_app_switch = _resolveComponent("app-switch");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: _normalizeClass(['coverage-box-top', {
      active: $data.block == 1
    }]),
    onClick: _cache[0] || (_cache[0] = $event => $options.onBlock(1))
  }, [_hoisted_5, _createVNode(_component_app_icon, {
    icon: "chevron-down2",
    size: 20,
    color: "#616161",
    class: "chevron",
    style: _normalizeStyle(`transform: rotate(${$data.block != 1 ? -90 : 0}deg)`)
  }, null, 8, ["style"])], 2), _createElementVNode("div", {
    class: _normalizeClass(['coverage-box-content', {
      open: $data.block == 1
    }])
  }, [_hoisted_6, _hoisted_7, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_app_icon, {
    icon: "info-circle",
    id: "fc-1",
    onClick: _cache[1] || (_cache[1] = $event => $options.onPopover('fc', 1))
  })]), _createElementVNode("div", {
    class: "coverage-cell-value",
    onClick: _cache[6] || (_cache[6] = _withModifiers($event => $options.onFocus('supplier_manufacturing_leadtime'), ["stop"]))
  }, [_withDirectives(_createElementVNode("input", {
    type: "number",
    ref: "supplier_manufacturing_leadtime",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $options.currentSettings.supplier_manufacturing_leadtime = $event),
    class: "coverage-input",
    onBlur: _cache[3] || (_cache[3] = (...args) => $options.onUpdate && $options.onUpdate(...args)),
    onKeyup: _cache[4] || (_cache[4] = _withKeys($event => $options.onBlur('supplier_manufacturing_leadtime'), ["enter"])),
    onInput: _cache[5] || (_cache[5] = $event => $options.onUpdateFbaBuffer($event, 'supplier_manufacturing_leadtime'))
  }, null, 544), [[_vModelText, $options.currentSettings.supplier_manufacturing_leadtime]])]), _hoisted_11]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_app_icon, {
    icon: "info-circle",
    id: "fc-2",
    onClick: _cache[7] || (_cache[7] = $event => $options.onPopover('fc', 2))
  })]), _createElementVNode("div", {
    class: "coverage-cell-value",
    onClick: _cache[12] || (_cache[12] = _withModifiers($event => $options.onFocus('supplier_preparation_leadtime'), ["stop"]))
  }, [_withDirectives(_createElementVNode("input", {
    type: "number",
    ref: "supplier_preparation_leadtime",
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $options.currentSettings.supplier_preparation_leadtime = $event),
    class: "coverage-input",
    onBlur: _cache[9] || (_cache[9] = (...args) => $options.onUpdate && $options.onUpdate(...args)),
    onKeyup: _cache[10] || (_cache[10] = _withKeys($event => $options.onBlur('supplier_preparation_leadtime'), ["enter"])),
    onInput: _cache[11] || (_cache[11] = $event => $options.onUpdateFbaBuffer($event, 'supplier_preparation_leadtime'))
  }, null, 544), [[_vModelText, $options.currentSettings.supplier_preparation_leadtime]])]), _hoisted_15]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_component_app_icon, {
    icon: "info-circle",
    id: "fc-3",
    onClick: _cache[13] || (_cache[13] = $event => $options.onPopover('fc', 3))
  })]), _createElementVNode("div", {
    class: "coverage-cell-value",
    onClick: _cache[18] || (_cache[18] = _withModifiers($event => $options.onFocus('supplier_to_fufillment_center_leadtime'), ["stop"]))
  }, [_withDirectives(_createElementVNode("input", {
    type: "number",
    ref: "supplier_to_fufillment_center_leadtime",
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $options.currentSettings.supplier_to_fufillment_center_leadtime = $event),
    class: "coverage-input",
    onBlur: _cache[15] || (_cache[15] = (...args) => $options.onUpdate && $options.onUpdate(...args)),
    onKeyup: _cache[16] || (_cache[16] = _withKeys($event => $options.onBlur('supplier_to_fufillment_center_leadtime'), ["enter"])),
    onInput: _cache[17] || (_cache[17] = $event => $options.onUpdateFbaBuffer($event, 'supplier_to_fufillment_center_leadtime'))
  }, null, 544), [[_vModelText, $options.currentSettings.supplier_to_fufillment_center_leadtime]])]), _hoisted_19]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createVNode(_component_app_icon, {
    icon: "info-circle",
    id: "fc-4",
    onClick: _cache[19] || (_cache[19] = $event => $options.onPopover('fc', 4))
  })]), _createElementVNode("div", {
    class: "coverage-cell-value",
    onClick: _cache[24] || (_cache[24] = _withModifiers($event => $options.onFocus('fufillment_center_preparation_leadtime'), ["stop"]))
  }, [_withDirectives(_createElementVNode("input", {
    type: "number",
    ref: "fufillment_center_preparation_leadtime",
    "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $options.currentSettings.fufillment_center_preparation_leadtime = $event),
    class: "coverage-input",
    onBlur: _cache[21] || (_cache[21] = (...args) => $options.onUpdate && $options.onUpdate(...args)),
    onKeyup: _cache[22] || (_cache[22] = _withKeys($event => $options.onBlur('fufillment_center_preparation_leadtime'), ["enter"])),
    onInput: _cache[23] || (_cache[23] = $event => $options.onUpdateFbaBuffer($event, 'fufillment_center_preparation_leadtime'))
  }, null, 544), [[_vModelText, $options.currentSettings.fufillment_center_preparation_leadtime]])]), _hoisted_23])]), _hoisted_24, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_hoisted_27, _createVNode(_component_app_icon, {
    icon: "info-circle",
    id: "fc-5",
    onClick: _cache[25] || (_cache[25] = $event => $options.onPopover('fc', 5))
  })]), _createElementVNode("div", {
    class: "coverage-cell-value",
    onClick: _cache[30] || (_cache[30] = _withModifiers($event => $options.onFocus('target_order_frequency'), ["stop"]))
  }, [_withDirectives(_createElementVNode("input", {
    type: "number",
    ref: "target_order_frequency",
    "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $options.currentSettings.target_order_frequency = $event),
    class: "coverage-input",
    onBlur: _cache[27] || (_cache[27] = (...args) => $options.onUpdate && $options.onUpdate(...args)),
    onKeyup: _cache[28] || (_cache[28] = _withKeys($event => $options.onBlur('target_order_frequency'), ["enter"])),
    onInput: _cache[29] || (_cache[29] = $event => $options.onUpdateFbaBuffer($event))
  }, null, 544), [[_vModelText, $options.currentSettings.target_order_frequency]])]), _hoisted_28]), _createElementVNode("div", {
    class: _normalizeClass(['coverage-row', {
      purple: $options.currentSettings.fba_buffer_stock_custom == $options.fbaBufferStock,
      blue: $options.currentSettings.fba_buffer_stock_custom != $options.fbaBufferStock
    }])
  }, [_createElementVNode("div", _hoisted_29, [_hoisted_30, _createElementVNode("div", _hoisted_31, [_hoisted_32, _createVNode(_component_app_icon, {
    icon: "info-circle",
    size: 12,
    color: "#fff"
  })]), _createVNode(_component_app_popover, {
    target: "learn-more",
    placement: "top",
    class: "learn-more-popover"
  }, {
    default: _withCtx(() => [_hoisted_33, _hoisted_34]),
    _: 1
  })]), _createElementVNode("div", {
    class: "coverage-cell-value",
    onClick: _cache[35] || (_cache[35] = _withModifiers($event => $options.onFocus('fba_buffer_stock_custom'), ["stop"]))
  }, [_withDirectives(_createVNode(_component_app_icon, {
    icon: "ai",
    size: 16,
    color: "#312783"
  }, null, 512), [[_vShow, $options.currentSettings.fba_buffer_stock_custom == $options.fbaBufferStock]]), _withDirectives(_createElementVNode("div", {
    class: "coverage-reset",
    id: "reset-button",
    onClick: _cache[31] || (_cache[31] = _withModifiers((...args) => $options.onReset && $options.onReset(...args), ["stop"]))
  }, [_createVNode(_component_app_icon, {
    icon: "reset"
  })], 512), [[_vShow, $options.currentSettings.fba_buffer_stock_custom != $options.fbaBufferStock]]), _createVNode(_component_app_popover, {
    target: "reset-button",
    placement: "top"
  }, {
    default: _withCtx(() => [_createTextVNode(" Reset override ")]),
    _: 1
  }), _createElementVNode("input", {
    type: "number",
    ref: "fba_buffer_stock_custom",
    class: "coverage-input",
    value: $options.currentSettings.fba_buffer_stock_custom,
    onBlur: _cache[32] || (_cache[32] = (...args) => $options.onUpdate && $options.onUpdate(...args)),
    onKeyup: _cache[33] || (_cache[33] = _withKeys($event => $options.onBlur('fba_buffer_stock_custom'), ["enter"])),
    onInput: _cache[34] || (_cache[34] = $event => $options.onUpdateFbaBufferCustom($event))
  }, null, 40, _hoisted_35)]), _hoisted_36], 2), _createElementVNode("div", _hoisted_37, [_hoisted_38, _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, _toDisplayString($options.totalCoverage), 1)]), _hoisted_41])])], 2), _createVNode(_component_demand_forecasting_settings_popover, {
    number: 1,
    max: 5,
    show: $data.popover.fc == 1,
    prefix: "fc",
    onPopover: $options.onPopover,
    title: "Supplier Manufacturing LT"
  }, {
    default: _withCtx(() => [_createTextVNode(" This parameter refers to the time Amazon takes to process and prepare the incoming goods for sale (including inspection, storage, and listing the product on the Amazon platform). ")]),
    _: 1
  }, 8, ["show", "onPopover"]), _createVNode(_component_demand_forecasting_settings_popover, {
    number: 2,
    max: 5,
    show: $data.popover.fc == 2,
    prefix: "fc",
    onPopover: $options.onPopover,
    title: "Supplier Preparation LT"
  }, {
    default: _withCtx(() => [_createTextVNode(" This parameter refers to the time Amazon takes to process and prepare the incoming goods for sale (including inspection, storage, and listing the product on the Amazon platform). ")]),
    _: 1
  }, 8, ["show", "onPopover"]), _createVNode(_component_demand_forecasting_settings_popover, {
    number: 3,
    max: 5,
    show: $data.popover.fc == 3,
    prefix: "fc",
    onPopover: $options.onPopover,
    title: "Supplier to AMZ transport LT"
  }, {
    default: _withCtx(() => [_createTextVNode(" This parameter refers to the time Amazon takes to process and prepare the incoming goods for sale (including inspection, storage, and listing the product on the Amazon platform). ")]),
    _: 1
  }, 8, ["show", "onPopover"]), _createVNode(_component_demand_forecasting_settings_popover, {
    number: 4,
    max: 5,
    show: $data.popover.fc == 4,
    prefix: "fc",
    onPopover: $options.onPopover,
    title: "AMZ preparation leadtime"
  }, {
    default: _withCtx(() => [_createTextVNode(" This parameter refers to the time Amazon takes to process and prepare the incoming goods for sale (including inspection, storage, and listing the product on the Amazon platform). ")]),
    _: 1
  }, 8, ["show", "onPopover"]), _createVNode(_component_demand_forecasting_settings_popover, {
    number: 5,
    max: 5,
    show: $data.popover.fc == 5,
    prefix: "fc",
    onPopover: $options.onPopover,
    title: "Target order frequency"
  }, {
    default: _withCtx(() => [_createTextVNode(" This parameter represents how often purchase orders are placed with the supplier. It can be defined in various time frames such as daily, weekly, monthly, etc., depending on the business model and demand patterns. ")]),
    _: 1
  }, 8, ["show", "onPopover"])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", {
    class: _normalizeClass(['coverage-box-top', {
      active: $data.block == 2
    }]),
    onClick: _cache[36] || (_cache[36] = $event => $options.onBlock(2))
  }, [_hoisted_43, _createVNode(_component_app_icon, {
    icon: "chevron-down2",
    size: 20,
    color: "#616161",
    class: "chevron",
    style: _normalizeStyle(`transform: rotate(${$data.block != 2 ? -90 : 0}deg)`)
  }, null, 8, ["style"])], 2), _createElementVNode("div", {
    class: _normalizeClass(['coverage-box-content', {
      open: $data.block == 2
    }])
  }, [_hoisted_44, _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_hoisted_48, _createVNode(_component_app_icon, {
    icon: "info-circle",
    id: "sm-1",
    onClick: _cache[37] || (_cache[37] = $event => $options.onPopover('sm', 1))
  })]), _createVNode(_component_app_input, {
    type: "number",
    modelValue: $options.currentSettings.velocity_threshold,
    "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => $options.currentSettings.velocity_threshold = $event),
    v2: "",
    append: "units",
    "append-simple": "",
    onBlur: $options.onUpdate,
    onKeyup: _withKeys($options.onUpdate, ["enter"])
  }, null, 8, ["modelValue", "onBlur", "onKeyup"])]), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_hoisted_51, _createVNode(_component_app_icon, {
    icon: "info-circle",
    id: "sm-2",
    onClick: _cache[39] || (_cache[39] = $event => $options.onPopover('sm', 2))
  })]), _createVNode(_component_app_input, {
    type: "number",
    modelValue: $options.currentSettings.target_inventory,
    "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => $options.currentSettings.target_inventory = $event),
    v2: "",
    append: "units",
    "append-simple": "",
    onBlur: $options.onUpdate,
    onKeyup: _withKeys($options.onUpdate, ["enter"])
  }, null, 8, ["modelValue", "onBlur", "onKeyup"])])])], 2), _createVNode(_component_demand_forecasting_settings_popover, {
    number: 1,
    max: 2,
    show: $data.popover.sm == 1,
    prefix: "sm",
    onPopover: $options.onPopover,
    title: "30d velocity threshold"
  }, {
    default: _withCtx(() => [_createTextVNode(" This parameter is used to identify slow-moving items in your inventory. It sets a sales velocity threshold, typically the number of units sold in a 30-day period, below which an item is classified as a slow mover. ")]),
    _: 1
  }, 8, ["show", "onPopover"]), _createVNode(_component_demand_forecasting_settings_popover, {
    number: 2,
    max: 2,
    show: $data.popover.sm == 2,
    prefix: "sm",
    onPopover: $options.onPopover,
    title: "Target inventory"
  }, {
    default: _withCtx(() => [_createTextVNode(" This parameter refers to the targeted inventory level for slow-moving items. It's generally lower than fast-moving items to prevent excessive capital from being tied up in inventory. ")]),
    _: 1
  }, 8, ["show", "onPopover"])]), _hoisted_52, _createElementVNode("div", _hoisted_53, [_hoisted_54, _createVNode(_component_app_switch, {
    modelValue: $options.currentSettings.packaging_required,
    "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => $options.currentSettings.packaging_required = $event),
    simple: "",
    onChange: $options.onUpdate
  }, null, 8, ["modelValue", "onChange"])])])]);
}